{
  "title": "Question of the Day",
  "cta": "Learn more"
}
